export const parseVendorLocationFilters = (locationKeys = [], locationLevels = []) => {
  const keys = Array.isArray(locationKeys) ? locationKeys : []
  const levelKeySet = new Set()
  const sectionKeySet = new Set()

  keys.forEach(key => {
    const normalizedKey = String(key ?? '').trim()
    if (!normalizedKey) {
      return
    }

    const matchingLevel = locationLevels.find(level => level.key === normalizedKey)
    if (matchingLevel) {
      levelKeySet.add(normalizedKey)
      return
    }

    const parentLevel = locationLevels.find(level =>
      (level.sections || []).some(section => section.key === normalizedKey)
    )

    if (parentLevel) {
      levelKeySet.add(parentLevel.key)
      sectionKeySet.add(normalizedKey)
    }
  })

  return {
    levelKeys: [...levelKeySet],
    sectionKeys: [...sectionKeySet]
  }
}

export const getSectionOptionsForSelectedLevels = (locationLevels = [], selectedLevelKeys = []) =>
  (Array.isArray(selectedLevelKeys) ? selectedLevelKeys : []).flatMap(levelKey => {
    const level = locationLevels.find(item => item.key === levelKey)
    if (!level) {
      return []
    }

    return (level.sections || []).map(section => ({
      key: section.key,
      label: section.label,
      levelKey: level.key
    }))
  })

export const buildVendorLocationFilterKeys = (
  selectedLevelKeys = [],
  selectedSectionKeys = [],
  locationLevels = []
) => {
  const result = []

  ;(Array.isArray(selectedLevelKeys) ? selectedLevelKeys : []).forEach(levelKey => {
    const level = locationLevels.find(item => item.key === levelKey)
    if (!level) {
      return
    }

    const sections = level.sections || []
    if (!sections.length) {
      result.push(levelKey)
      return
    }

    const selectedForLevel = (Array.isArray(selectedSectionKeys) ? selectedSectionKeys : [])
      .filter(sectionKey => sections.some(section => section.key === sectionKey))

    result.push(...selectedForLevel)
  })

  return [...new Set(result)]
}
